import { useRouter } from 'next/router'
import { ErrorBoundary } from 'react-error-boundary'
import { useState } from 'react'

import { RoleContentProvider } from 'app/KinerjaShared/components/RoleContentProvider'
import { ToggleSdkContext } from 'utils/useToogleSdk'
import KinerjaLayoutBase from 'app/KinerjaShared/components/KinerjaLayoutBase'
import { KinerjaErrorBoundary } from 'app/KinerjaShared/components/KinerjaErrorBoundary'
import PeriodProvider from 'app/KinerjaShared/components/PeriodProvider'

import type { CustomError } from 'types/custom-error'
import type { FallbackProps } from 'react-error-boundary'
import type { KinerjaLayoutBase as KinerjaLayoutBaseProps } from 'types/kinerja-layout'
import type { KinerjaLayoutPage } from 'types/kinerja-layout'
import type { SKPPeriodV2 } from 'types/kinerja'

export type PageProps = KinerjaLayoutPage
export type KinerjaLayoutProps = KinerjaLayoutBaseProps

export type TFallbackProps = Omit<FallbackProps, 'error'> & {
  error: CustomError | Error
  resetErrorBoundary: (...args: Array<unknown>) => void
}

const title = 'Pengelolaan Kinerja'

const KinerjaLayout = (props: KinerjaLayoutProps) => {
  const { asPath } = useRouter()
  const [periodId, setPeriodId] = useState<SKPPeriodV2['id']>(null)

  return (
    <>
      <ToggleSdkContext.Provider value={props?.pageProps?.toggle}>
        {/* Handle error on account specific */}
        <ErrorBoundary
          resetKeys={[asPath]}
          FallbackComponent={(errorProps: TFallbackProps) => (
            <KinerjaErrorBoundary
              {...errorProps}
              layoutProps={{ title, ...props }}
            />
          )}
        >
          <PeriodProvider onPeriodChange={(p) => setPeriodId(p?.id)}>
            {/* Handle error on period specific, user may change period as the Ganti Periode option will be available */}
            <ErrorBoundary
              resetKeys={[asPath, periodId]}
              FallbackComponent={(errorProps: TFallbackProps) => (
                <KinerjaErrorBoundary
                  {...errorProps}
                  layoutProps={{ title, ...props }}
                />
              )}
            >
              <RoleContentProvider
                disableLoading // Prevent loading spinner to take over the screen when loading the user profile
              >
                <KinerjaLayoutBase title={title} {...props} />
              </RoleContentProvider>
            </ErrorBoundary>
          </PeriodProvider>
        </ErrorBoundary>
      </ToggleSdkContext.Provider>
    </>
  )
}

export default KinerjaLayout
